import { supabase } from "../lib/api";

export const deleteLink = async (linkId: number) => {
  return await supabase.from("links").delete().eq("id", linkId);
};
